// @flow
import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';
import { py, mx } from 'styled-components-spacing';

import theme from '@theme';

const { colors } = theme;

export const StyledList = styled.ul`
  ${py(2.5)}
`;

export const StyledListItem = styled.li`
  border-bottom: solid 1px ${colors.separator};
  cursor: pointer;
`;

export const StyledListItemContent = styled.a`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-decoration: none;
  color: black;
  transition: 0.3s;
  :hover {
    background-color: #57a1bb;
    color: white;
  }

  & > div {
    display: flex;
  }
`;

export const StyledCatagoryName = styled.p`
  ${mx(2.5)}
  font-size: 18px;
  ${py(2)}
  display: flex;
  flex: 1;
  font-weight: bold;
  ${({ active }) => active && 'color: #57A1BB'};
  :hover {
    color: inherit;
  }

  ${breakpoint('mobile', 'tablet')`
    font-size: 16px;
  `}
`;
